var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        visible: _vm.visible,
        title: _vm.$t("fixDutyFine.processPenaltyTitle"),
        width: "600px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "penalty-dialog-content" }, [
        _c(
          "div",
          { staticClass: "info-block" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(_vm._s(_vm.$t("fixDutyFine.selected"))),
                    ]),
                    _c("span", { staticClass: "info-value text-bold" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.count) +
                          " " +
                          _vm._s(_vm.$t("fixDutyFine.ticketsUnit")) +
                          " "
                      ),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(_vm._s(_vm.$t("base.billingMonth"))),
                    ]),
                    _c("span", { staticClass: "info-value" }, [
                      _vm._v(_vm._s(_vm.month || "--")),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "radio-group-block" },
          [
            _c(
              "el-radio-group",
              {
                staticClass: "custom-radio-group",
                model: {
                  value: _vm.actionType,
                  callback: function ($$v) {
                    _vm.actionType = $$v
                  },
                  expression: "actionType",
                },
              },
              [
                _c(
                  "el-radio",
                  { staticClass: "custom-radio", attrs: { label: 1 } },
                  [
                    _c("span", { staticClass: "radio-text" }, [
                      _vm._v(_vm._s(_vm.$t("fixDutyFine.accept"))),
                    ]),
                  ]
                ),
                _c(
                  "el-radio",
                  { staticClass: "custom-radio", attrs: { label: 2 } },
                  [
                    _c("span", { staticClass: "radio-text" }, [
                      _vm._v(_vm._s(_vm.$t("fixDutyFine.appeal"))),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "textarea-block" },
          [
            _c("el-input", {
              attrs: {
                placeholder:
                  _vm.actionType === 2
                    ? _vm.$t("fixDutyFine.appealReasonPlaceholder")
                    : _vm.$t("fixDutyFine.acceptReasonPlaceholder"),
                rows: 4,
                maxlength: "500",
                "show-word-limit": "",
                type: "textarea",
              },
              model: {
                value: _vm.reason,
                callback: function ($$v) {
                  _vm.reason = $$v
                },
                expression: "reason",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("fixDutyFine.cancel"))),
          ]),
          _c(
            "el-button",
            {
              attrs: { loading: _vm.submitting, type: "success" },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v(_vm._s(_vm.$t("fixDutyFine.confirmSubmit")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }